import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DateTimeDisplay from '../date-time-display';

function DateRenderer(props) {
  const { value, format, relative } = props;
  return (
    <div>
      <DateTimeDisplay value={value} format={format} relative={relative} />
    </div>
  );
}
DateRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(moment),
  ]),
  format: PropTypes.string,
  relative: PropTypes.bool,
};
DateRenderer.defaultProps = {
  value: null,
  format: 'short',
  relative: false,
};

export default DateRenderer;
